import { Check, X } from "lucide-react";

/**
 * Big, visible on/off toggle for admin panels.
 * Replaces the tiny ToggleLeft/ToggleRight icons with a proper switch.
 */
export const BigToggle = ({ value, onChange, testId, disabled }) => (
  <button
    type="button"
    role="switch"
    aria-checked={!!value}
    disabled={disabled}
    onClick={() => onChange(!value)}
    data-testid={testId}
    className={`relative inline-flex items-center h-7 w-14 shrink-0 rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-emerald-500 disabled:opacity-50 ${
      value
        ? "bg-emerald-500 hover:bg-emerald-600"
        : "bg-slate-300 dark:bg-slate-600 hover:bg-slate-400"
    }`}
  >
    <span
      className={`absolute left-1.5 transition-opacity ${value ? "opacity-100" : "opacity-0"}`}
    >
      <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
    </span>
    <span
      className={`absolute right-1.5 transition-opacity ${value ? "opacity-0" : "opacity-100"}`}
    >
      <X className="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" strokeWidth={3} />
    </span>
    <span
      aria-hidden="true"
      className={`pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow ring-1 ring-black/10 transition-transform duration-200 ${
        value ? "translate-x-7" : "translate-x-0.5"
      }`}
    />
  </button>
);

export default BigToggle;
